import { BaseState, CalledTypeLiterals } from "../consts/base-state";
import { EnvLiteral } from "@graffer-inc/graffer-design-kit";

export type AccountsEnvLiteral =
  | "production"
  | "production_sandbox"
  | "staging"
  | "staging_sandbox"
  | "development"
  | "development_sandbox"
  | "local";

type EnvMappingType = {
  [key in AccountsEnvLiteral]: EnvLiteral;
};

const envMapping: EnvMappingType = {
  production: "production",
  production_sandbox: "production_sandbox",
  staging: "staging",
  staging_sandbox: "staging_sandbox",
  development: "dev",
  development_sandbox: "dev",
  local: "local",
};

export const convertEnv = (env: AccountsEnvLiteral): EnvLiteral =>
  envMapping[env];

type EnvStateHashType = {
  [key in AccountsEnvLiteral]: string;
};

const EnvStateHash: EnvStateHashType = {
  local: "",
  production: "",
  production_sandbox: "sandbox-",
  staging: "staging-",
  staging_sandbox: "staging-sandbox-",
  development: "dev-",
  // TODO(adshidtadka): dev-sandbox環境は削除されたため型定義からも消す
  development_sandbox: "dev-sandbox-",
} as const;

export class EnvState extends BaseState<AccountsEnvLiteral> {
  constructor(props: string) {
    super(props as AccountsEnvLiteral);
  }
  matchLocal<R>(
    matcher: CalledTypeLiterals<"isLocal" | "notLocal", void, R>,
  ): R {
    if (this.equals("local")) {
      return matcher.isLocal();
    }
    return matcher.notLocal();
  }
  matchSandbox<R>(
    matcher: CalledTypeLiterals<
      "sandbox" | "production" | "staging" | "development",
      void,
      R
    >,
  ): R {
    return this.match({
      local: matcher.sandbox,
      production: matcher.production,
      production_sandbox: matcher.sandbox,
      staging: matcher.staging,
      staging_sandbox: matcher.sandbox,
      development: matcher.development,
      development_sandbox: matcher.sandbox,
    });
  }
  getPrefix() {
    return EnvStateHash[this.getValue()] as string;
  }
}

const envState = new EnvState(process.env.NEXT_PUBLIC_ENVIRONMENT!);
export default envState;
